class Transporter {
  active = String;
  class_name = String;
  countiesAvailabilities = Object;
  countiesPricing = Object;
  deliveryCost = Number;
  deliveryOptionType = String;
  has_vouchers = String;
  id = String;
  lang = String;
  name = String;
  options = Object;
  postalCodesAvailabilities = Array;
  postalCodesPricing = Object;
  send_weight = String;
  slug = String;
  sort = Number;
  transportationCost = Number;
  transporter_id = String;
  useTransporterWidget = Boolean;
}

export default class SmartPointWidget {
  selectedTransporter = new Transporter();

  constructor (selectedTransporter) {
    this.selectedTransporter = selectedTransporter
  }

  initializeWidget () {
    switch (this.selectedTransporter.class_name) {
      case 'BOXNOW':
        return this.initializeWidgetBoxNow()
      default:
        return Promise.reject(new Error('No widget found.'))
    }
  }

  async initializeWidgetBoxNow () {
    window._bn_map_widget_config = {
      partnerId: 123,
      parentElement: '#boxnowmap',
      type: 'iframe',
      autoselect: false,
      afterSelect: function (payload) {
        const ignoredEvents = [
          'vue-devtools-backend',
          'vue-devtools-proxy',
          'vue-devtools-backend-injection'
        ]
        if ('source' in payload && ignoredEvents.includes(payload.source)) {
          return
        }
        if ('boxnowLockerId' in payload) {
          window.Vue.$emit('BOXNOW_AfterSelect', payload)
          window.Vue.$emit('modal-close', payload)
        }
      }
    }
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.src = 'https://widget-cdn.boxnow.gr/map-widget/client/v4.js'
    script.async = true
    script.defer = true
    const head = document.getElementsByTagName('head')[0]
    head.appendChild(script)
    return new Promise((resolve, reject) => {
      script.onload = () => {
        resolve()
      }
      script.onerror = () => {
        reject(new Error('Error loading script.'))
      }
    })
  }
}
